var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":this.url,"title":"W3Schools Free Online Web Tutorials"}})])])],1)],1)])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }